import React from 'react';
import AdConfigDashboard from './components/AdConfigDashboard';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <AdConfigDashboard />
      </div>
    </ErrorBoundary>
  );
}

export default App;